<div class="entity-config-page container-fluid">
  <div class="entity-config-shell d-flex flex-column gap-0 mx-auto px-2">
    <section class="rounded-4 overflow-hidden mb-1">
      <div class="pt-2 pb-1 mb-3">
        <div class="row g-2 align-items-start">
          <div class="col">
            <div class="text-uppercase text-xxs text-dark opacity-75 d-flex align-items-center gap-2 mb-2">
              <span>Home</span>
              <span>/</span>
              <span>Overview</span>
            </div>
            <h1 class="entity-page-title text-dark fw-bold lh-sm mb-2">{{ greeting_title }}</h1>
            <div class="entity-page-subtitle requestor-summary-copy mb-0">
              <template v-for="(segment, index) in summary_segments" :key="`${segment.text}-${index}`">
                <strong v-if="segment.strong" class="text-dark">{{ segment.text }}</strong>
                <span v-else>{{ segment.text }}</span>
              </template>
            </div>
          </div>
        </div>
      </div>

      <div class="pb-0">
        <section class="row entity-config-top-metrics g-2">
          <div v-for="metric in metrics" :key="metric.label" class="col-12 col-sm-6 col-xl-3 mb-2">
            <article class="entity-metric-card h-100 rounded-4 border shadow p-3">
              <div class="d-flex align-items-start justify-content-between gap-3">
                <div class="d-flex flex-column justify-content-start pt-1 ps-2">
                  <span class="entity-metric-label secondary-color text-uppercase fw-bold d-block mb-2">
                    {{ metric.label }}
                  </span>
                  <div class="entity-metric-value secondary-color fw-bold lh-1 mb-0 mt-1">{{ metric.value }}</div>
                  <div class="text-x mb-0 mt-2" :class="metric.detail_class">{{ metric.detail }}</div>
                </div>
                <div class="entity-metric-icon rounded-3 d-inline-flex align-items-center justify-content-center mt-2 me-1 text-white">
                  <i class="bi" :class="metric.icon"></i>
                </div>
              </div>
            </article>
          </div>
        </section>
      </div>
    </section>

    <section class="row g-2 mt-2 align-items-start">
      <div class="col-12 col-xl-8">
        <div class="entity-detail-panel entity-detail-panel-vibrant rounded-4 border shadow-sm p-3 h-100 mt-0">
          <div class="d-flex align-items-center justify-content-between gap-2 mb-3">
            <div>
              <h2 class="fs-6 fw-bold mb-1">Today&apos;s priority queue</h2>
              <div class="entity-panel-caption small text-dark">Ordered by SLA risk x case value</div>
            </div>
            <button type="button" class="btn btn-link p-0 text-decoration-none small fw-semibold entity-binding-card-link" @click="go_to_queue">
              View all 142 <i class="bi bi-arrow-right-short"></i>
            </button>
          </div>

          <div class="d-flex flex-column gap-2">
            <article
              v-for="item in queue_items"
              :key="item.case_code"
              class="entity-row-card requestor-queue-card bg-white rounded-4 border shadow-sm p-3 case-clickable-card"
              :class="`is-${item.accent_tone}`"
              @click="go_to_case_detail(item.case_code)"
            >
              <div class="row g-3 align-items-center">
                <div class="col-12 col-lg-8">
                  <span class="badge rounded-pill fw-normal mb-2" :class="`requestor-chip is-${item.chip_tone}`">
                    {{ item.chip }}
                  </span>
                  <div class="fw-bold small text-dark mb-1">{{ item.title }}</div>
                  <div class="small text-secondary">{{ item.meta }}</div>
                </div>
                <div class="col-12 col-lg-4 d-flex justify-content-lg-end">
                  <button
                    type="button"
                    class="btn btn-sm rounded-small px-3 btn-light border secondary-color"
                    @click.stop="go_to_case_detail(item.case_code)"
                  >
                    {{ item.action_label }} <i class="bi bi-arrow-right-short"></i>
                  </button>
                </div>
              </div>
            </article>
          </div>
        </div>
      </div>

      <div class="col-12 col-xl-4">
        <div class="entity-detail-panel entity-detail-panel-vibrant rounded-4 border shadow-sm p-3 h-100 mt-0">
          <div class="d-flex align-items-center justify-content-between gap-2 mb-3">
            <div>
              <h2 class="fs-6 fw-bold mb-1">Activity</h2>
            </div>
            <div class="text-uppercase text-xxs secondary-color">Last 24h</div>
          </div>

          <div class="entity-vibrant-binding-card rounded-4 p-3 bg-white mb-3">
            <div class="d-flex flex-column gap-3">
              <article
                v-for="(item, index) in activity_items"
                :key="`${item.meta}-${index}`"
                class="d-flex align-items-start gap-3 pb-3 border-bottom requestor-activity-item"
              >
                <span class="status-dot-md rounded-circle mt-1" :class="item.dot_class"></span>
                <div class="min-w-0">
                  <div class="text-uppercase text-xxs secondary-color mb-1">{{ item.meta }}</div>
                  <div class="small text-dark">{{ item.text }}</div>
                </div>
              </article>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</div>
